<template>
  <div class="sc-suggestions-row" :style="{background: colors.button.bg}">
    <button
      class="sc-suggestions-element"
      v-for="(suggestion, idx) in chat.suggestions"
      @click="sendSuggestion($event, suggestion)"
      :style="{borderColor: colors.button.text, color: colors.button.text}"
      :key="idx"
    >{{suggestion.text}}</button>
  </div>
</template>

<script>
export default {
  name: 'Suggestions',
  inject: {
    chat: {
      type: Object
    },
    settings: {
      type: Object
    },
    colors: {
      type: Object
    }
  },
  methods: {
    sendSuggestion (event, suggestion) {
      this.chat.payload = suggestion
      this.chat.send = {
        event,
        source: 'quick-reply',
        data: {
          type: "quick_reply",
          data: suggestion
        }
      }
      this.settings.autoFlush && (this.chat.payload = null);
    }
  }
};
</script>

<style>
.sc-suggestions-row {
  text-align: center;
  background: inherit;
  padding-top:.25rem;
}

.sc-suggestions-element {
  margin: 0 0 .25rem .25rem;
  padding: .25rem .5rem;
  border: 1px solid;
  border-radius: 15px;
  font-size: .75rem;
  background: inherit;
  cursor: pointer;
  outline : 0; 
}
</style>
